import TfLaunch from '@/micro-app/tf-launch';

const routeConfig = [
  {
    title: '导购魔方',
    path: '/guidingBox',
    getLink({ path }) {
      return `${path}#/guiding-box`;
    },
    component: TfLaunch,
  },
  {
    title: '直播',
    path: '/live',
    getLink({ path }) {
      return `${path}#/live`;
    },
    component: TfLaunch,
  },
  {
    title: '智能Feeds流',
    path: '/feedsFlow',
    getLink({ path }) {
      return `${path}#/feeds-flow`;
    },
    component: TfLaunch,
  },
  {
    title: '定制化榜单',
    path: '/freshList',
    getLink({ path }) {
      return `${path}#/fresh-list`;
    },
    component: TfLaunch,
  },
];

export default routeConfig;
